import React, { useContext, useEffect, useState } from "react"
import { ScrollView, View } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { connect } from "react-redux"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { staticDataService } from "@data/services/staticDataService"
import { authService } from "@data/services/authService"
import SchoolSubjectModal from "../../organize/school-subjects/SchoolSubjectModal"
import { ModalM } from "@common/components/modal/ModalM"
import { Checkbox } from "react-native-paper"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { useNavigation } from "@react-navigation/native"
import StartingFormHeader from "./preparation-form/StartingFormHeader"
import { SelectInputM } from "./SelectInputM"
import { lyceeClasses, objectivesTab } from "./RegisterTrialSessionScreen"
import { useForm } from "react-hook-form"
import { congratsTypes } from "@common/screens/CongratsScreen"
import { putCongrats, putNextScreenParams } from "@data/redux/actions/navigation"
import SchoolSubjectSelector from "@common/components/select/SchoolSubjectSelect"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import TextInputM from "@common/components/input/TextInputM"

const subjectsColors = [theme.colors.accentLighter, theme.colors.primaryLighter, theme.colors.successLight]

const SchoolSubjectForm = (props) => {
    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()

    const [subjects, setSubjects] = useState([])
    const [modalVisible, setModalVisible] = useState(false)
    const [requestCall, setRequestCall] = useState(true)
    const [parentEvaluationComment, setParentEvaluationComment] = useState(null)
    const selectedClass = props.user?.profile?.class
    const filteredObjectivesTab = lyceeClasses.includes(selectedClass)
        ? objectivesTab.filter(option => option.value !== "Aide aux devoirs")
        : objectivesTab
    const firstname = props.user?.firstname

    const isStep1 = props.user.profile?.desired_support !== "Aide aux devoirs" && props.user.prioritized_school_subjects?.length === 0
    const isStep2 = props.user?.xp === 0
        && !props.user?.todo_activities?.find(todo => todo?.material?.title?.toLowerCase().includes("demande pour la séance"))
        && !props.user?.activities?.find(activity => activity?.material?.title?.toLowerCase().includes("demande pour la séance"))

    const { control, handleSubmit, formState: { errors, isDirty, dirtyFields }, watch } = useForm({
        defaultValues: {
            desired_support: props.user?.profile?.desired_support,
        },
    })
    const selectedSupport = watch("desired_support")
    const description = selectedSupport === "Aide aux devoirs" ? "Cette forme de soutien peut convenir si vous souhaitez un accompagnement global." :
        ``
    const description2 = selectedSupport === "Aide aux devoirs" ? "Nous vous proposerons un tuteur ou une tutrice compétent pour accompagner votre enfant globalement, dans les matières scientifiques et littéraires." : ""
    const isFormValid = subjects.length > 0 || selectedSupport === "Aide aux devoirs"

    useEffect(() => {
        if (!props.schoolSubjects) {
            props.apiRequest(staticDataService.getStaticDataTrial)
        }
    }, [])

    const schoolSubjects = props.schoolSubjects?.map((x) => ({
        label: x?.name,
        value: x?.id,
        icon: x?.icon,
    }))

    const handleSelectSubject = (selectedId) => {
        const selectedSubject = schoolSubjects.find((subject) => subject.value === selectedId)

        if (selectedSubject) {
            const isAlreadySelected = subjects.some((s) => s.value === selectedSubject.value)

            if (isAlreadySelected) {
                setSubjects(subjects.filter((s) => s.value !== selectedSubject.value))
            } else if (subjects?.length < 3) {
                setSubjects([
                    ...subjects,
                    {
                        id: selectedSubject?.value,
                        value: selectedSubject.value,
                        label: selectedSubject.label,
                        icon: selectedSubject?.icon,
                    },
                ])
            }
        }
    }

    const onSubmit = (data) => {
        const formattedSubjects = subjects.map(({ value }) => value)
        props.apiRequest(authService.postPrioritizedSchoolSubjects, {}, {
            prioritized_school_subjects: formattedSubjects,
            desired_support: selectedSupport,
            parent_call_requested: requestCall,
            parent_evaluation_comment: parentEvaluationComment,
        })
    }

    const onFinishSteps = () => {
        if (!props.user?.champion_intros_viewed_at?.zoe) {
            props.putNextScreenParams({
                name: "zoe",
            })

            const nextScreen = {
                nextScreen: "intro",
            }

            const congrats = []

            if (IS_WEB) {
                congrats.push({
                    congratsType: congratsTypes.DOWNLOAD_APP,
                    congratsData: {},
                })
            }

            props.putCongrats(congrats)
            navigation.replace("congrats", {
                ...nextScreen,
            })
        }
    }

    const onCloseStep = () => {
        if (!props.user?.champion_intros_viewed_at?.zoe) {
            DialogM.show({
                text1: "Quitter ce formulaire ?",
                text2: `Ces informations sont importantes pour préparer au mieux l’accompagnement de ${props.user.firstname}`,
                buttonText1: "Oui, quitter",
                onPress: () => {
                    onFinishSteps()
                },
                buttonText2: "Annuler",
            })
        } else {
            navigation.goBack()
        }
    }

    const onIgnoreStep = () => {
        navigation.goBack()
    }

    useApiStatus(
        authService.postPrioritizedSchoolSubjects, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {

            navigation.replace("trial-preparation-form")

        }, // success callback
    )

    return (
        <View
            style={{
                marginBottom: 10,
                width: dimensions?.width,
                flex: 1,
                alignSelf: "center",
            }}
        >
            <StartingFormHeader step={1}
                                totalSteps={2}
                                stepTitle={" Accompagnement souhaité"}
                                title={"Préparez votre essai"}
                                onClose={onIgnoreStep} />

            <ScrollView style={{ width: "100%" }}
                        contentContainerStyle={{
                            // flex: 1,
                            width: dimensions?.width - 20,
                            paddingHorizontal: 20,
                            alignItems: "stretch",
                        }}>
                <SelectInputM options={filteredObjectivesTab}
                              label={"Accompagnement souhaité"}
                              sliderLabel={"Accompagnement souhaité"}
                              name={"desired_support"}
                              onSelect={(value) => {
                                  if (value !== "Soutien sur une ou plusieurs matières")
                                      setSubjects([])
                              }}
                              control={control}
                              style={{ marginBottom: 10 }}
                              errors={errors}
                />
                <TextM color={theme.colors.greyAlt} style={{ marginVertical: 15 }} wrap>
                    {description}
                </TextM>
                {description2 && <TextM color={theme.colors.greyAlt} style={{ marginVertical: 15 }} wrap>
                    {description2}
                </TextM>}
                {selectedSupport === "Soutien sur une ou plusieurs matières" && <>
                    <TextM color={theme.colors.primary}
                           wrap
                           fontWeight={"Medium"}
                           fontSize={12}
                    >{"Choisir 1 à 3 matières"}</TextM>
                    <SchoolSubjectSelector
                        schoolSubjects={schoolSubjects}
                        subjects={subjects}
                        setSubjects={setSubjects}
                        loading={props.getStaticDataTrialRequest}
                    />
                </>
                }
                <View style={{ width: dimensions?.width - 40, marginTop: 20 }}>
                    <TextM
                        color={theme.colors.primary}
                        fontSize={12}
                        fontWeight={"Medium"}
                    >
                        {"Précisions sur les besoins de "+ props.user?.firstname}
                    </TextM>
                    <TextInputM
                        placeholder={props.user?.firstname +" a besoin de..."}
                        name="parent_evaluation_comment"
                        style={{
                            width: dimensions?.width - 40,
                            height: 120,
                            backgroundColor: theme.colors.white,
                            alignSelf: "center",
                            marginBottom: 20,
                        }}
                        multiline={true}
                        onChangeAdditional={(value) => {
                            setParentEvaluationComment(value)
                        }}
                        control={control}
                        errors={errors}
                    />
                </View>
                <Checkbox.Item label="J’aimerais échanger avec un conseiller pédagogique avant l’essai."
                               position={"leading"}
                               onPress={() => {
                                   setRequestCall(!requestCall)
                               }}
                               color={theme.colors.primary}
                               labelStyle={{
                                   fontSize: 14,
                                   textAlign: "left",
                               }}
                               style={{
                                   marginHorizontal: 5,
                                   width: dimensions?.width - 40,
                               }}
                               status={requestCall ? "checked" : "indeterminate"} />
            </ScrollView>
            <ModalM visible={modalVisible} onDismiss={() => setModalVisible(false)} style={{ height: "90%" }}>
                <SchoolSubjectModal onSelectSchoolSubject={handleSelectSubject}
                                    options={schoolSubjects}
                                    setVisible={setModalVisible}
                                    selectedSubjects={subjects?.map((subject, index) => subject?.value)}
                                    title={"Choisir 1 à 3 matières"}
                                    showExitBtn
                />
            </ModalM>
            <View style={{
                marginTop: 10,
                marginBottom: 0,
                position: "absolute",
                bottom: 0,
                alignSelf: "center",
            }}>
                <FilledButtonM

                    onPress={onSubmit}
                    loading={props.postPrioritizedSchoolSubjectsRequest}
                    disabled={props.postPrioritizedSchoolSubjectsRequest || !isFormValid}
                    label="Continuer"
                />
                {/*<FilledButtonM*/}
                {/*    onPress={onIgnoreStep}*/}
                {/*    mode={"text"}*/}
                {/*    label={"Compléter plus tard"}*/}
                {/*/>*/}
            </View>
        </View>
    )
}

const mapStateToProps = (state) => ({
    schoolSubjects: state.data.staticData?.school_subjects,
    postPrioritizedSchoolSubjectsRequest: state.api.postPrioritizedSchoolSubjects?.request,
    getStaticDataTrialRequest: state.api.getStaticDataTrial?.request,
    user: state.data.currentUser?.object,
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    putCongrats,
    putNextScreenParams,
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolSubjectForm)
